<template>
  <div v-if="internalTrustfund">
    <material-card
      :title="$t('components.plancreationwizard.trust_fund')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="business"
      style="margin-top: 30px"
    >
      <v-card-text>
        <v-form ref="form" v-model="valid" :disabled="disabled">
          <v-container fluid>
            <v-row>
              <v-col xs="12" sm="6" md="4" lg="3">
                <trans-textbox
                  v-model="internalTrustfund"
                  :label="$t('globals.name')"
                  field="Name"
                  :rules="[$rules.required]"
                  class="required"
                ></trans-textbox>
              </v-col>

              <v-col xs="12" sm="6" md="4" lg="3">
                <no-autocomplete-textfield
                  v-model="policyNumber"
                  :label="$t('globals.policy_number')"
                  :rules="[$rules.required]"
                  class="required"
                ></no-autocomplete-textfield>
              </v-col>

              <v-col xs="12" sm="6" md="4" lg="3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-container pa-0>
                      <v-row no-gutters>
                        <v-col>
                          <image-uploader-string
                            @image-data="
                              internalTrustfund.LogoBase64 = $event;
                              $forceUpdate();
                              $emit('trust-fund', internalTrustfund);
                            "
                            :image="internalTrustfund.LogoBase64"
                            :label="$t('globals.logo')"
                          ></image-uploader-string>
                        </v-col>
                        <v-col
                          style="margin-top: 20px; margin-left: 3px"
                          cols="auto"
                        >
                          <v-icon v-bind="attrs" v-on="on">help</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                  <span>
                    {{
                      $t(
                        "components.plancreationwizard.trust_fund_logo_tooltip"
                      )
                    }}
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col xs="12" sm="6" md="4" lg="4">
                <no-autocomplete-textfield
                  :value="internalTrustfund.PhoneNumber"
                  @change="
                    internalTrustfund.PhoneNumber = $event;
                    $emit('trust-fund', internalTrustfund);
                  "
                  :label="$t('globals.telephone')"
                  :rules="[rules.phone]"
                  v-mask="telephoneMask"
                ></no-autocomplete-textfield>
                <!-- <no-autocomplete-textfield
                  :value="internalTrustfund.PhoneNumber"
                  @change="
                    internalTrustfund.PhoneNumber = $event;
                    $emit('trust-fund', internalTrustfund);
                  "
                  :label="$t('globals.telephone')"
                  :rules="[$rules.phone]"
                ></no-autocomplete-textfield> -->
              </v-col>
              <v-col xs="12" sm="6" md="4" lg="4">
                <no-autocomplete-textfield
                  :value="internalTrustfund.Fax"
                  @change="
                    internalTrustfund.Fax = $event;
                    $emit('trust-fund', internalTrustfund);
                  "
                  :label="$t('globals.fax_number')"
                  :rules="[rules.phone]"
                  v-mask="telephoneMask"
                ></no-autocomplete-textfield>
                <!-- <no-autocomplete-textfield
                  :value="internalTrustfund.Fax"
                  @change="
                    internalTrustfund.Fax = $event;
                    $emit('trust-fund', internalTrustfund);
                  "
                  :label="$t('globals.fax_number')"
                  :rules="[$rules.phone]"
                ></no-autocomplete-textfield> -->
              </v-col>
              <v-col xs="12" sm="6" md="4" lg="4">
                <no-autocomplete-textfield
                  :value="internalTrustfund.Email"
                  @change="
                    internalTrustfund.Email = $event;
                    $emit('trust-fund', internalTrustfund);
                  "
                  :label="$t('headers.contacts.email')"
                  :rules="[$rules.email]"
                ></no-autocomplete-textfield>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <!-- <address-form
          ref="trustFundAddress"
          :item="internalTrustfund"
          :provinces="options.Models.Province"
          @valid="
            validAddress = $event;
            $emit('trust-fund', internalTrustfund);
          "
          :disabled="disabled"
        ></address-form> -->
        <span class="text-h6 ml-1">
          {{ $t("globals.address") }}
        </span>
        <canada-post-address
          :address="internalTrustfund.Address"
          @update-address="internalTrustfund.Address = $event"
          @valid="validAddress = $event"
        />
      </v-card-text>
    </material-card>
    <material-card
      :title="$t('components.plancreationwizard.bank_account')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="business"
      style="margin-top: 30px"
    >
      <v-form ref="bankAccountForm" v-model="validAccount">
        <v-container fluid>
          <v-row>
            <div class="col-12 col-md-4 col-lg-3">
              <no-autocomplete-textfield
                :label="$t('headers.members_management.Institution Number')"
                v-model="internalBankAccount.InstitutionNumber"
                :rules="[$rules.canadianBankInstitutionNumber, $rules.required]"
                :class="isBankAccountRequired() ? 'required' : ''"
              ></no-autocomplete-textfield>
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <no-autocomplete-textfield
                :label="$t('headers.members_management.Account Number')"
                v-model="internalBankAccount.AccountNumber"
                :rules="[$rules.canadianBankAccountNumber, $rules.required]"
                :class="isBankAccountRequired() ? 'required' : ''"
              ></no-autocomplete-textfield>
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <no-autocomplete-textfield
                :label="$t('headers.members_management.Transit Number')"
                v-model="internalBankAccount.TransitNumber"
                :rules="[$rules.canadianBankTransitNumber, $rules.required]"
                :class="isBankAccountRequired() ? 'required' : ''"
              ></no-autocomplete-textfield>
            </div>
          </v-row>
        </v-container>
      </v-form>
    </material-card>
    <contacts
      style="margin-top: 20px"
      @contacts-changed="internalTrustfund.Contacts = $event"
      :contacts="internalTrustfund.Contacts"
      identifier="trustFundContacts"
      :planIdentityId="planIdentityId"
    ></contacts>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Contacts from "@/components/PlanBuilder/Contacts";
import TransTextbox from "@/components/TransTextbox";
import ImageUploaderString from "@/components/ImageUploaderString";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
// import AddressForm from "@/components/AddressForm";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import CanadaPostAddress from "@/components/CanadaPostAddress";

export default {
  components: {
    Contacts,
    TransTextbox,
    ImageUploaderString,
    NoAutocompleteTextfield,
    // AddressForm,
    CanadaPostAddress,
  },
  props: [
    "trustFund",
    "planIdentityId",
    "disabled",
    "planEffectiveDate",
    "hasBeneficiaries",
    "bankAccount",
  ],
  directives: { mask },
  mounted() {
    console.log("trustfund mounted: ", this.trustFund);
    if (this.trustFund !== null && this.trustFund !== undefined) {
      this.internalTrustfund = this.trustFund;
      if (
        this.trustFund.PolicyIdentity !== null &&
        this.trustFund.PolicyIdentity !== undefined
      ) {
        this.policyNumber = this.trustFund.PolicyIdentity.History[0].Number;
      }
    }
    console.log(this.bankAccount);
    if (this.bankAccount !== null && this.bankAccount !== undefined) {
      this.internalBankAccount = this.bankAccount;
    }
  },
  data() {
    return {
      valid: false,
      validAddress: true,
      validAccount: false,
      internalTrustfund: null,
      policyNumber: null,
      internalBankAccount: null,
      telephoneMask: "(###) ### - ####",
      rules: {
        phone: (v) => {
          let val = this.unmask(v, this.telephoneMask);
          return !val || this.$rules.phone(val);
        },
      },
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    activeStatus() {
      return this.options.Models.Status.filter((o) => o.Name === "Active")[0];
    },
  },
  watch: {
    trustFund: {
      handler(v) {
        this.internalTrustfund = v;
        if (
          v !== null &&
          v !== undefined &&
          v.PolicyIdentity !== null &&
          v.PolicyIdentity !== undefined
        ) {
          this.policyNumber = v.PolicyIdentity.History[0].Number;
        }
      },
    },
    internalTrustfund: {
      handler(v) {
        this.$emit("trust-fund", v);
      },
      deep: true,
    },
    bankAccount: {
      handler(v) {
        this.internalBankAccount = v;
      },
    },
    internalBankAccount: {
      handler(v) {
        this.$emit("bank-account", v);
      },
      deep: true,
    },
    policyNumber: {
      handler(v) {
        if (v !== null && v !== undefined) {
          if (
            this.internalTrustfund.PolicyIdentity === null ||
            this.internalTrustfund.PolicyIdentity === undefined
          ) {
            this.internalTrustfund.PolicyIdentity = {
              History: [
                {
                  EffectiveDate: this.planEffectiveDate,
                  StatusId: this.activeStatus.Id,
                },
              ],
            };
          }
          this.internalTrustfund.PolicyIdentity.History[0].Number =
            this.policyNumber;
          this.$emit("trust-fund", this.internalTrustfund);
        }
      },
      deep: true,
    },
    valid: {
      handler(v) {
        console.log(
          "valid tf:",
          v,
          this.isBankAccountValid(),
          this.validAddress,
          this.validAccount
        );
        this.$emit(
          "valid",
          v &&
            this.isBankAccountValid() &&
            this.validAddress &&
            this.validAccount
        );
      },
    },
    validAddress: {
      handler(v) {
        console.log(
          "valid address:",
          v,
          this.isBankAccountValid(),
          this.valid,
          this.validAccount
        );
        this.$emit(
          "valid",
          v && this.isBankAccountValid() && this.valid && this.validAccount
        );
      },
    },
    validAccount: {
      handler(v) {
        console.log(
          "valid ba:",
          v,
          this.isBankAccountValid(),
          this.validAddress,
          this.valid
        );
        this.$emit("valid", this.isBankAccountValid() && this.validAddress && this.valid);
      },
    },
  },
  methods: {
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    isBankAccountRequired() {
      if (
        this.internalBankAccount === null ||
        this.internalBankAccount === undefined
      ) {
        this.internalBankAccount = {};
        return false;
      }
      for (let key of Object.keys(this.internalBankAccount)) {
        console.log(key);
        if (
          this.internalBankAccount[key] === null ||
          this.internalBankAccount[key] === ""
        ) {
          delete this.internalBankAccount[key];
        }
      }
      if (Object.keys(this.internalBankAccount).length === 0) {
        if (this.$refs.bankAccountForm) {
          this.$refs.bankAccountForm.resetValidation();
        }
        return false;
      }
      return true;
    },
    isBankAccountValid() {
      if (
        this.internalBankAccount === null ||
        this.internalBankAccount === undefined
      ) {
        this.$emit("valid", this.valid && this.validAddress);
        return true;
      }
      for (let key of Object.keys(this.internalBankAccount)) {
        console.log(key);
        if (
          this.internalBankAccount[key] === null ||
          this.internalBankAccount[key] === ""
        ) {
          delete this.internalBankAccount[key];
        }
      }
      if (Object.keys(this.internalBankAccount).length === 0) {
        if (this.$refs.bankAccountForm) {
          this.$refs.bankAccountForm.resetValidation();
        }
        this.$emit("valid", this.valid && this.validAddress);
        return true;
      }
      this.$emit("valid", this.validAccount && this.valid && this.validAddress);
      return this.validAccount;
    },
  },
};
</script>
